module.exports = __webpack_public_path__ + "assets/img/healthcareSolutions-researchSolutions.c31de78e.png";